import { Request } from '~src/httpClient/serverApi/requests/Request';

import { ISiteTrial, TrialType } from '../../types/ISiteTrial';

export interface IGetTrialsParams {
  trialType?: TrialType;
}

export interface IGetTrialsResult {
  trials: ISiteTrial[];
}

export class GetTrialsRequest extends Request<IGetTrialsParams, IGetTrialsResult> {
  constructor(params?: IGetTrialsParams) {
    super('getTrials', params ?? {});
  }
}
